/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
import React from 'react'
import { useStateMachine } from 'little-state-machine'
import { clearAction } from './actions'
import { initialStates } from '../../../hooks/useLittleMachine'
import Select from 'react-select'
import { Controller, useFieldArray, useForm } from 'react-hook-form'
import { AlertErrorForm } from '../../../components/AlertErrorForm'
import { mainSchemaCreateEvent } from './schemas'
import { yupResolver } from '@hookform/resolvers/yup'
import { Link, useNavigate } from 'react-router-dom'
import { FormButtons } from '../../../components/Events/FormButtons'
import { eventService } from '../../../services/event.service'
import { useGeneralApp } from '../../../hooks/useGeneralApp'
import moment from 'moment'
export const InformationSummary = () => {
  const { setErrorMessage, setIsLoading } = useGeneralApp()
  const navigate = useNavigate()
  const { actions, state: { createEvent } } = useStateMachine({ clearAction })
  const { register, handleSubmit, control, formState: { errors } } = useForm({
    resolver: yupResolver(mainSchemaCreateEvent),
    defaultValues: createEvent
  })
  const { fields } = useFieldArray({ control, name: 'boletos' })
  const onSubmit = async (data) => {
    try {
      setIsLoading(true)

      const eventData = {
        event: {
          nombre_organizador: data.nombre_organizador,
          celular_principal: data.celular_principal,
          celular_secundario: data.celular_secundario,
          nombre_evento: data.nombre_evento,
          fecha_evento: moment(data.fecha_evento).format(),
          hora_inicio: data.hora_inicio,
          hora_final: data.hora_final,
          ubicacion: data.ubicacion,
          descripcion: data.descripcion,
          // ubicacion_maps: data.ubicacion_maps,
          latitud: data.latitud,
          longitud: data.longitud,
          direccion: data.direccion,
          url_video: data.url_video,
          tipo_cobro: data.tipo_cobro,
          foto_evento: data.foto_evento,
          itinerario_evento: data.itinerario_evento,
          ciudad: data.ciudad
        },
        nombre_artista: data.nombre_organizador,
        ticket: [...data.boletos],
        ids_categorias: [...data.categorias.map(c => (c.value))],
        estado: {
          id: data.estado.value
        }
      }
      await eventService.createOneEvent(eventData)
      setIsLoading(false)
      actions.clearAction({ payload: initialStates })
      navigate('/eventos/revision')
    } catch (error) {
      console.log(error)
      if (!error.response) {
        setErrorMessage('⚠️ Servicios desconectados, estamos en mantenimiento ⚠️')
      }
      if (error.response.data.msg) {
        setErrorMessage('Revisa los campos')
      } else {
        setErrorMessage(error.response.data.msg)
      }
      setIsLoading(false)
    }
  }
  return (
    <>
      <form className="summary-container" onSubmit={handleSubmit(onSubmit)}>
        <h1 className="h2 pt-xl-1 pb-3 text-primary">Resumen</h1>
        <div className='section-summary'>
          {/* Organizer */}
          <h2 className="h5 text-primary mb-4">Datos del organizador</h2>
          <div className="border-bottom pb-3 pb-lg-4">
            <div className="row pb-2">
              <div className="col-sm-12 mb-4">
                <label htmlFor="fn" className="form-label fs-base text-white">Nombre del organizador</label>
                <input type="text"
                  id="fn" className="form-control form-control-lg"
                  {...register('nombre_organizador')}
                  disabled
                />
                {errors.nombre_organizador && (<AlertErrorForm messageError={errors.nombre_organizador.message} />)}

              </div>
              <div className="col-sm-6 mb-4">
                <label htmlFor="sn" className="form-label fs-base text-white">Celular principal</label>
                <input type="text" id="sn"
                  className="form-control form-control-lg"
                  {...register('celular_principal')}
                  disabled
                />
                {errors.celular_principal && (<AlertErrorForm messageError={errors.celular_principal.message} />)}
              </div>
              <div className="col-sm-6 mb-4">
                <label htmlFor="sn" className="form-label fs-base text-white">Celular secundario</label>
                <input type="text" id="sn"
                  className="form-control form-control-lg"
                  {...register('celular_secundario')}
                  disabled
                />
                {errors.celular_secundario && (<AlertErrorForm messageError={errors.celular_secundario.message} />)}
              </div>
            </div>
          </div>
        </div>
        <div className="section-sumary">
          <h2 className="h5 text-primary mb-4">Datos del evento</h2>
          <div className="border-bottom pb-3 pb-lg-4" onSubmit={handleSubmit(onSubmit)}>
            <div className="row pb-2">
              <div className="col-sm-12 mb-4">
                <label htmlFor="nombre" className="form-label fs-base text-white">Nombre del evento</label>
                <input type="text"
                  id="nombre" className="form-control form-control-lg"
                  {...register('nombre')}
                  disabled
                />
                {errors.nombre_evento && (<AlertErrorForm messageError={errors.nombre_evento.message} />)}
              </div>
              <div className="col-sm-12 mb-4">
                <label htmlFor="descripcion" className="form-label fs-base text-white">Descripcion del evento</label>
                <textarea type="text"
                  id="descripcion" className="form-control form-control-lg"
                  {...register('descripcion')}
                  disabled
                />
                {errors.descripcion && (<AlertErrorForm messageError={errors.descripcion.message} />)}
              </div>
              <div className="col-sm-4 mb-4">
                <label htmlFor="fecha_evento" className="form-label fs-base text-white">Fecha de evento</label>
                <input type="date" id="fecha_evento"
                  className="form-control form-control-lg"
                  {...register('fecha_evento')}
                  disabled
                />
                {errors.fecha_evento && (<AlertErrorForm messageError={errors.fecha_evento.message} />)}
              </div>
              <div className="col-sm-4 mb-4">
                <label htmlFor="hora_inicio" className="form-label fs-base text-white">Hora inicio</label>
                <input type="time"
                  id="hora_inicial"
                  className="form-control form-control-lg"
                  disabled
                  {...register('hora_inicio')}
                />
                {errors.hora_inicio && (<AlertErrorForm messageError={errors.hora_inicio.message} />)}
              </div>
              <div className="col-sm-4 mb-4">
                <label htmlFor="hora_final" className="form-label fs-base text-white">Hora final</label>
                <input type="time"
                  id="hora_inicial"
                  className="form-control form-control-lg"
                  disabled
                  {...register('hora_final')}
                />
                {errors.hora_final && (<AlertErrorForm messageError={errors.hora_final.message} />)}
              </div>
              <div className="col-sm-6 mb-4">
                <label htmlFor="ubicacion" className="form-label fs-base text-white">Nombre del lugar</label>
                <input type="text" id="ubicacion"
                  className="form-control form-control-lg"
                  {...register('ubicacion')}
                  disabled
                />
                {errors.ubicacion && (<AlertErrorForm messageError={errors.ubicacion.message} />)}
              </div>
              {/* <div className="col-sm-6 mb-4">
                <label htmlFor="ubicacion_maps" className="form-label fs-base">Selecciona la ubicación en maps</label>
                <input type="text" id="ubicacion_maps"
                  className="form-control form-control-lg"
                  {...register('ubicacion_maps')}
                  disabled
                />
                {errors.ubicacion_maps && (<AlertErrorForm messageError={errors.ubicacion_maps.message} />)}
              </div> */}
              <div className="col-sm-3 mb-4">
                <label htmlFor="latitud" className="form-label fs-base text-white">Latitud</label>
                <input type="text" id="latitud"
                  className="form-control form-control-lg"
                  {...register('latitud')}
                  disabled
                />
                {errors.latitud && (<AlertErrorForm messageError={errors.latitud.message} />)}
              </div>
              <div className="col-sm-3 mb-4">
                <label htmlFor="longitud" className="form-label fs-base text-white">Longitud</label>
                <input type="text" id="longitud"
                  className="form-control form-control-lg"
                  {...register('longitud')}
                  disabled
                />
                {errors.longitud && (<AlertErrorForm messageError={errors.longitud.message} />)}
              </div>
              <div className="col-sm-12 col-md-6 mb-4">
                <label htmlFor="ciudad" className="form-label fs-base text-white">Ciudad</label>
                <input type="text"
                  id="ciudad" className="form-control form-control-lg"
                  {...register('ciudad')}
                  disabled
                />
                {errors.ciudad && (<AlertErrorForm messageError={errors.ciudad.message} />)}
              </div>
              <div className="col-sm-12 col-md-6 mb-4">
                <label htmlFor="estado" className="form-label fs-base text-white">Estado</label>
                <input type="text"
                  id="estado" className="form-control form-control-lg"
                  {...register('estado')}
                  disabled
                />
                {errors.estado && (<AlertErrorForm messageError={errors.estado.message} />)}
              </div>
              <div className="col-sm-12 mb-4">
                <label htmlFor="direccion" className="form-label fs-base text-white">Dirección del evento</label>
                <textarea type="text"
                  id="direccion" className="form-control form-control-lg"
                  {...register('direccion')}
                  disabled
                />
                {errors.direccion && (<AlertErrorForm messageError={errors.direccion.message} />)}
              </div>
              <div className="col-sm-12 col-md-4 mb-4">
                <label htmlFor="video" className="form-label fs-base text-white">Url de video youtube (Opcional)</label>
                <input type="text" id="video"
                  className="form-control form-control-lg"
                  {...register('video')}
                  disabled
                />
                {errors.url_video && (<AlertErrorForm messageError={errors.url_video.message} />)}
              </div>
              <div className="col-sm-12 col-md-4 mb-4">
                <label htmlFor="foto_portada" className="form-label fs-base text-white">Foto de evento</label>
                <input type="text" id="foto_portada"
                  className="form-control form-control-lg"
                  {...register('foto_portada')}
                  disabled
                />
                {errors.foto_portada && (<AlertErrorForm messageError={errors.foto_evento.message} />)}
              </div>
              <div className="col-sm-12 col-md-4 mb-4">
                <label htmlFor="itinerario_evento" className="form-label fs-base text-white">Itinerario de evento (.pdf)</label>
                <input type="text" id="itinerario_evento"
                  className="form-control form-control-lg"
                  {...register('itinerario_evento')}
                  disabled
                />
                {errors.itinerario_evento && (<AlertErrorForm messageError={errors.itinerario_evento.message} />)}
              </div>
              <div className="col-sm-12 mb-4">
                <label htmlFor="categorias" className="form-label fs-base text-white">Selecciona las categorias a las que pertenece tu evento</label>
                <Controller
                  name="categorias"
                  control={control}
                  render={({ field }) =>
                    <Select
                      {...field}
                      placeholder="Selecciona tu categoria"
                      isMulti
                      isDisabled
                    />}
                />
                {errors.categorias && (<AlertErrorForm messageError={errors.categorias.message} />)}
              </div>
            </div>
          </div>
        </div>
        {/* TIckets */}
        <div className="section-summary">
          <h2 className="h5 text-primary mb-4">Información de boletos</h2>
          <div className="border-bottom pb-3 pb-lg-4" onSubmit={handleSubmit(onSubmit)}>
            <div className="row pb-2">
              <div className="col-sm-12 mb-4">
                <div className="form-check">
                  <label htmlFor="tipo_cobro" className="form-label fs-base text-white">¿Es evento de pago?</label>
                  <input
                    type="checkbox"
                    {...register('tipo_cobro')}
                    id="tipo_cobro"
                    className="form-check-input ml-4"
                    disabled
                  />
                </div>
                {errors.tipo_cobro && (<AlertErrorForm messageError={errors.tipo_cobro.message} />)}
              </div>
              {
                (createEvent.tipo_cobro) && (<>

                  <div className="col-sm-12 mb-4">
                    <label
                      htmlFor="metodos_pago"
                      className="form-label fs-base">
                      Selecciona los métodos de pagos disponibles para el evento
                    </label>
                    {/* Metodos */}
                    <Controller
                      name="metodos_pago"
                      control={control}
                      render={({ field }) =>
                        <Select
                          {...field}
                          placeholder="Métodos de pago"
                          isMulti
                          isDisabled
                        />}
                    />

                    {errors.metodos_pago && (<AlertErrorForm messageError={errors.metodos_pago.message} />)}
                  </div>
                  <div className="col-sm-12 mb-4">
                    <div className="form-check">
                      <label htmlFor="habra_boletos" className="form-label fs-base">¿Tendrás varios tipos de boletos?</label>
                      <input
                        type="checkbox"
                        {...register('habra_boletos')}
                        id="habra_boletos"
                        className="form-check-input ml-4"
                        checked={createEvent.habra_boletos}
                        disabled
                      />
                    </div>
                  </div>

                  {errors.boletos && (<AlertErrorForm messageError={errors.boletos.message} />)}
                  {(createEvent.habra_boletos) && (
                    <>
                      {
                        fields.map((item, index) => {
                          return (
                            <div key={item.id} className='form-control my-2'>
                              <div className="mb-4">
                                <label htmlFor="text-input" className="form-label">
                                  Nombre del boleto
                                </label>
                                <Controller
                                  name={`boletos.${index}.nombre`}
                                  control={control}
                                  render={({ field }) => (
                                    <input
                                      {...field}
                                      className="form-control"
                                      type="text" id="text-input"
                                      disabled
                                    />
                                  )}
                                />
                              </div>

                              <div className="mb-4">
                                <label htmlFor="number-input" className="form-label">
                                  Cantidad de boletos disponibles
                                </label>
                                <Controller
                                  name={`boletos.${index}.cantidad`}
                                  control={control}
                                  render={({ field }) => (
                                    <input
                                      {...field}
                                      className="form-control"
                                      type="number"
                                      id="cantidad"
                                      disabled
                                    />
                                  )}
                                />

                              </div>

                              <div className="mb-4">
                                <label htmlFor="number-input" className="form-label">
                                  Precio del boleto (MXN - Peso mexicano)
                                </label>
                                <Controller
                                  name={`boletos.${index}.precio`}
                                  control={control}
                                  render={({ field }) => (
                                    <input
                                      {...field}
                                      disabled
                                      className="form-control"
                                      type="number"
                                      id="precio"
                                    />
                                  )}
                                />
                              </div>
                            </div>
                          )
                        })
                      }
                    </>
                  )}
                </>
                )
              }

            </div>
          </div>
        </div>
        <div className="row my-4">
          <div className="col-sm-12 mb-4">
            <div className="form-check">
              <label htmlFor="acepto_terminos" className="form-label fs-base text-white">
                He leído y acepto los términos y condiciones.
                <Link to="/terminos-condiciones" className='text-muted'> Ver términos y condiciones</Link>
              </label>
              <input
                type="checkbox"
                {...register('acepto_terminos')}
                id="acepto_terminos"
                className="form-check-input ml-4"
              />
            </div>
            {errors.acepto_terminos && (<AlertErrorForm messageError={errors.acepto_terminos.message} />)}
          </div>
        </div>
        <div className="mt-4">
          <FormButtons backPage="/crear-evento/informacion-evento" msgNextBtn="Crear evento" />
        </div>
      </form >
    </>
  )
}
